import { useEffect, useState } from "react";
import {
  PayPalScriptProvider, PayPalButtons, PayPalCardFieldsProvider,
  PayPalCardFieldsForm, usePayPalCardFields, FUNDING,
} from "@paypal/react-paypal-js";
import api, { apiError } from "@/lib/api";
import { toast } from "sonner";
import { eur, Loading } from "@/components/common";

function CardSubmit() {
  const { cardFieldsForm } = usePayPalCardFields();
  const [busy, setBusy] = useState(false);
  return (
    <button
      type="button"
      data-testid="paypal-card-submit"
      disabled={!cardFieldsForm || busy}
      onClick={async () => {
        setBusy(true);
        try {
          await cardFieldsForm.submit();
        } catch {
          setBusy(false);
        }
      }}
      className="btn-primary w-full mt-4 disabled:opacity-60"
    >
      {busy ? "Pagamento in corso…" : "Paga con carta"}
    </button>
  );
}

export default function PayPalCheckout({ paymentId, amount, method, onSuccess, onCancel }) {
  const [cfg, setCfg] = useState(null);

  useEffect(() => {
    api.get("/config").then((r) => setCfg(r.data)).catch(() => setCfg({ paypal_enabled: false }));
  }, []);

  if (!cfg) return <Loading />;

  if (!cfg.paypal_enabled) {
    return (
      <div className="text-sm text-amber-900 bg-amber-50 border border-amber-200 rounded-xl px-4 py-3" data-testid="paypal-not-configured">
        I pagamenti online non sono ancora attivi su questo ambiente. Puoi completare l'ordine scegliendo il bonifico bancario.
      </div>
    );
  }

  const createOrder = async () => {
    const { data } = await api.post("/customer/paypal/orders", { payment_id: paymentId });
    return data.id;
  };

  const onApprove = async (data) => {
    try {
      await api.post(`/customer/paypal/orders/${data.orderID}/capture`, { payment_id: paymentId });
      onSuccess();
    } catch (e) {
      toast.error(apiError(e));
    }
  };

  const onError = () => toast.error("Pagamento non riuscito. Riprova o contattaci.");

  return (
    <div data-testid="paypal-checkout" className="space-y-3">
      <PayPalScriptProvider
        options={{
          clientId: cfg.paypal_client_id,
          currency: "EUR",
          intent: "capture",
          components: "buttons,card-fields",
        }}
      >
        {method === "paypal" ? (
          <PayPalButtons
            fundingSource={FUNDING.PAYPAL}
            style={{ layout: "vertical", shape: "pill", label: "pay" }}
            createOrder={createOrder}
            onApprove={onApprove}
            onError={onError}
            onCancel={onCancel}
            data-testid="paypal-buttons"
          />
        ) : (
          <PayPalCardFieldsProvider createOrder={createOrder} onApprove={onApprove} onError={onError}>
            <div className="card-soft p-4" data-testid="paypal-card-fields">
              <p className="text-xs text-muted-soft mb-3">Visa e Mastercard, anche senza conto PayPal. Pagamento sicuro tramite PayPal.</p>
              <PayPalCardFieldsForm />
              <CardSubmit />
            </div>
          </PayPalCardFieldsProvider>
        )}
      </PayPalScriptProvider>
      <p className="text-[11px] text-muted-soft text-center">Totale: <span className="font-semibold text-navy">{eur(amount)}</span> · pagamento elaborato da PayPal</p>
    </div>
  );
}
